import Vue from 'vue'
import store from '@g/store'
import App from '@/App.vue'
import Home from '@/views/home/NoLoginHome.vue'
import { setDefaultHeader } from '@g/store/axiosProvider'
import { rememberReferrer } from '@g/utils/referrerStorage'
import { createHomepageRouter } from './router'
import './bootstrap'

async function mount () {
  if (window.kkrenHomepageBridge && window.kkrenHomepageBridge()) return
  rememberReferrer()
  await setDefaultHeader()
  window.vueApp = new Vue({
    el: '#site-app',
    store,
    router: createHomepageRouter(),
    render: h => h(App, { props: { homepage: true } }, [h(Home, { props: { standalone: true } })]),
  })
  await Vue.nextTick()
  window._initSuccess = true
  window.__KKREN_HOME_READY__ = true
}

mount()
